<template>
  <div class="main">
    <div class="title1 mt20">修改密码 <span class="f-small">密码修改完成后需要您重新登录</span></div>
    <Form :label-width="150" class="mt20">
     <!-- <FormItem class="ivu-form-item-required" label="邮箱">
        <Input v-model.trim="form_data.email" placeholder="请输入邮箱" style="width:400px" />
      </FormItem>
      <FormItem class="ivu-form-item-required" label="邮箱验证码">
        <Input v-model.trim="form_data.email_valid_code" maxlength="6" placeholder="请输入邮箱验证码" style="width:280px" />
        <Button class="b-btn small" @click="getSmscode" :disabled="num > 0">{{num ? num : isAgain ? '重新获取验证码' : '获取验证码'}}</Button>
      </FormItem> -->
      <FormItem class="ivu-form-item-required" label="旧密码">
        <Input v-model.trim="form_data.old_password" placeholder="请输入旧密码" style="width:400px" />
      </FormItem>
      <FormItem class="ivu-form-item-required" label="新密码">
        <Input v-model.trim="form_data.new_password" placeholder="请输入新密码，不得少于6位的数字或字母" style="width:400px" />
      </FormItem>
      <FormItem class="ivu-form-item-required" label="确认新密码">
        <Input v-model.trim="new_password_2" placeholder="请输入确认新密码" style="width:400px" />
      </FormItem>
    </Form>
    <div class="tc">
      <button class="purple-btn" @click="save">确定保存</button>
    </div>
  </div>
</template>
<script>
  export default {
    components: {

    },
    data() {
      return {
        new_password_2: "",
        form_data: {
          new_password: "",
          old_password: "",
          email: "",
          email_valid_code: "",
        },
        num: 0,
        timer: null,
        isAgain: false
      };
    },
    methods: {
      getSmscode() { //获取短信验证码
        if (!this.$global.checkEmail(this.form_data.email)) {
          this.$Message.warning("请输入正确的邮箱");
          return
        }
        this.$axios.post('/common/email/valid', this.$qs.stringify({
          email: this.form_data.email
        })).then(res => {
          if (res.success) {
            this.isAgain = true
            this.num = 60
            this.timer = setInterval(() => {
              this.num--
              if (this.num === 0) {
                clearInterval(this.timer)
              }
            }, 1000)
          }
        })
      },
      /**
       * 保存
       * */
      save() {
        this.new_password_2 = this.new_password_2.trim();
        // if (!this.form_data.email) {
        //   this.$Message.warning("请输入邮箱");
        //   return
        // }
        // if (!this.$global.checkEmail(this.form_data.email)) {
        //   this.$Message.warning("请输入正确的邮箱");
        //   return
        // }
        // if (!this.form_data.email_valid_code) {
        //   this.$Message.warning("请输入邮箱验证码");
        //   return
        // }
        if (!this.form_data.old_password) {
          this.$Message.warning("请输入旧密码");
          return
        }

        if (!this.form_data.new_password) {
          this.$Message.warning("请输入新密码");
          return
        }
        if (this.form_data.new_password.length < 6) {
          this.$Message.warning("密码长度不足六位");
          return
        }
        if (!this.new_password_2) {
          this.$Message.warning("请输入确认新密码");
          return
        }
        if (this.new_password_2 !== this.form_data.new_password) {
          this.$Message.warning("两次新密码不一致");
          return
        }
        this.$axios.put("/client/password", this.$qs.stringify(this.form_data)).then(res => {
          if (res.success) {
            this.$Message.success("修改成功,请重新登录");
            localStorage.setItem("token", "");
            this.$router.push({
              path: "/Login"
            })
          }
        })
      }
    },
    created() {}
  };
</script>
<style lang="scss">
  .title1 .f-small {
    font-size: 12px;
    color: #999999;
  }

  .b-btn.small {
    padding: 0 20px;
    vertical-align: middle;
    line-height: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/client_mgr/changepassword.vue